export default "__VITE_ASSET__CZLVWC8L__"